import React from 'react';
import cx from 'classnames';
import moment from 'moment';
import { SizeMe } from 'react-sizeme';
import { Text, Button, Icon } from '../../../ui-kit';
import mediaSizes from '../../../common/constants/mediaSizes';
import '../styles/_subscriptionInfoBox.scss';






export default function SubscriptionInfoBox(
{ subscription: { name, trial, endDate }, onClick })
{
  const now = moment();

  const remainingDays = -Math.round(moment.duration(now.diff(endDate)).asDays());

  const isExpired = remainingDays < 1;
  const isWithinWeek = remainingDays < 7 && remainingDays >= 0;

  const remainingTimeText = `${isExpired ? 'expired' : `${remainingDays} days remaining`}`;

  const standardExpiredText = `All your ${name} content that has been created will remain 
                              accessible. Subscribe to continue creating new content.`;

  const castExpiredText = `Don't worry! All of your ${name} content will remain accessible and you
                           can still create new ${name}s with limited functionality. 
                           Contact us to find out more.`;

  const expiredText = name === 'Cast' ? castExpiredText : standardExpiredText;

  return (
    <SizeMe>
      {({ size: { width } }) =>
      <div className={cx(
        'subscription-info-box',
        { 'subscription-info-box--medium': width < mediaSizes.medium },
        { 'subscription-info-box--small': width < mediaSizes.small }
      )}>

          <div className="subscription-info-box__description">
            <div className="subscription-info-box__description__time">
              <div>
                <Text heading5>
                  {`Your Shootsta ${name} ${trial ? 'trial' : 'subscription'} ${isExpired ? 'is' : 'has'}`}
                 &nbsp;
                </Text>
              </div>
              <div>
                <Text
                success={remainingDays > 7}
                danger={isExpired}
                warning={isWithinWeek}
                heading5>

                  {`${remainingTimeText}`}
                </Text>
              </div>
            </div>
            {isExpired ?

          <Text>
                  {expiredText}
                </Text> :

          null}

          </div>
          {!trial && isWithinWeek ?
        <Text className="subscription-info-box__cta">Ready to renew?</Text> :
        null}

          {width > mediaSizes.small ?
        <Button className="subscription-info-box__button" type={isExpired ? 'PRIMARY' : 'SECONDARY'} onClick={onClick}>Get in touch</Button> :
        <div className="subscription-info-box__button"><Icon name="chevronright" onClick={onClick} /></div>}

        </div>}

    </SizeMe>);

}

SubscriptionInfoBox.defaultProps = {
  subscription: { name: 'APP1', trial: true }
};